import React from 'react';
import Container from 'react-bootstrap/Container';

const ConstructionPage: React.FC = () => {
    return (
        <Container style={{ paddingTop: '50px', textAlign: 'center' }}>
            <h1>This page is currently under construction</h1>
        </Container>
    );
};

export default ConstructionPage;